import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, getFormValues, initialize } from 'redux-form';
import swal from 'sweetalert2';

import { init } from './usuarioActions';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';
import Button from '../common/form/button';
import SelectGrupoUsuario from '../common/selectdb/selectGrupoUsuario';
import SelectGrupoFisicoUsuario from '../common/selectdb/SelectGrupoFisicoUsuario';

const renderSelectGrupoFisico = ({ input, label, cols, readOnly, ...props }) => (
  <SelectGrupoFisicoUsuario
    {...input}
    label={label}
    cols={cols}
    value={input.value}
    onChange={value => input.onChange(value)}
    disabled={readOnly || props.readOnly}
  />
);

class UsuarioForm extends Component {
  // Verificar se o usuário logado é administrador (grupo 1)
  isUserAdmin = () => {
    const { user } = this.props;
    return user && user.grupo_idgrupo === 1;
  };

  ensureSelfInitialValues = () => {
    const { user, initialValues, initializeForm, selectedTab } = this.props;

    if (!user || !user.token) return;

    // Só preencher dados se estiver na aba de edição (tabUpdate) e não na de inclusão (tabCreate)
    if (selectedTab === 'tabCreate') {
      return;
    }

    const decoded = this.decodeToken(user.token);
    const uid = decoded && decoded.id;
    if (!uid) return;
    if (!initialValues || !initialValues.id) {
      const seed = {
        id: uid,
        nome: decoded && decoded.nome ? decoded.nome : '',
        usuario: decoded && decoded.usuario ? decoded.usuario : '',
        grupo_idgrupo: decoded && decoded.grupo_idgrupo ? decoded.grupo_idgrupo : '',
      };
      initializeForm('usuarioForm', seed);
    }
  };

  componentDidMount() {
    this.ensureSelfInitialValues();
  }

  componentDidUpdate(prevProps) {
    // Se mudou para a aba tabCreate, limpar o formulário
    if (prevProps.selectedTab !== this.props.selectedTab && this.props.selectedTab === 'tabCreate') {
      this.props.initializeForm('usuarioForm', {});
      return;
    }

    if (
      prevProps.user !== this.props.user ||
      prevProps.initialValues !== this.props.initialValues ||
      prevProps.selectedTab !== this.props.selectedTab
    ) {
      this.ensureSelfInitialValues();
    }
  }

  // Decodificar token JWT para obter o ID do usuário
  decodeToken = token => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Erro ao decodificar token:', e);
      return null;
    }
  };

  // Verificar se está editando o próprio usuário
  isEditingSelf = () => {
    const { user, formValues, initialValues } = this.props;

    // Garantir que temos os valores necessários
    const hasFormId = !!(formValues && formValues.id) || !!(initialValues && initialValues.id);
    if (!user || !user.token || (!formValues && !initialValues) || !hasFormId) {
      return false;
    }

    // Decodificar o token para obter o ID do usuário
    const decodedToken = this.decodeToken(user.token);
    const userId = decodedToken ? String(decodedToken.id).trim() : '';
    const currentId = (formValues && formValues.id) != null ? formValues.id : initialValues && initialValues.id;
    const formId = currentId != null ? String(currentId).trim() : '';

    const result = userId === formId && userId !== '';
    return result;
  };

  // Verificar se deve bloquear campos para não administradores
  shouldBlockFields = () => {
    const isAdmin = this.isUserAdmin();
    const isEditingSelf = this.isEditingSelf();
    const shouldBlock = !isAdmin && !isEditingSelf;

    // Bloquear apenas se NÃO é admin E NÃO está editando a si mesmo
    return shouldBlock;
  };

  checkEmail = () => {
    const { formValues } = this.props;

    if (formValues.usuario && !formValues.usuario.includes('@')) {
      swal({
        title: 'Atenção',
        text: 'Informe um email válido',
        type: 'warning',
        confirmButtonColor: 'primary',
        confirmButtonText: 'OK',
      });

      return false;
    }

    return true;
  };
  checkPasswords = () => {
    const { formValues } = this.props;

    if (formValues.senha !== formValues.confirmarSenha) {
      swal({
        title: 'Atenção',
        text: 'Senhas não conferem',
        type: 'warning',
        confirmButtonColor: 'primary',
        confirmButtonText: 'OK',
      });

      return false;
    }

    return true;
  };

  checkGrupoUsuario = () => {
    const { formValues } = this.props;

    if (!formValues.grupo_idgrupo || formValues.grupo_idgrupo === '') {
      swal({
        title: 'Atenção',
        text: 'Selecione um Grupo de Usuário',
        type: 'warning',
        confirmButtonColor: 'primary',
        confirmButtonText: 'OK',
      });

      return false;
    }

    return true;
  };

  submitForm = event => {
    // handleSubmit é uma função do reduxForm
    const { handleSubmit } = this.props;

    // prevent default do form
    event.preventDefault();

    const validations = [this.checkEmail(), this.checkPasswords(), this.checkGrupoUsuario()];

    if (validations.every(success => success)) {
      handleSubmit();
    }

    return false;
  };

  render() {
    // os eventos handleSubmit, vem do reduxForm
    const { readOnly, formValues } = this.props;
    const isAdmin = this.isUserAdmin();
    const isEditingSelf = this.isEditingSelf();
    const shouldBlockFields = this.shouldBlockFields();

    // Se não é admin e não está editando a si mesmo, bloquear todos os campos
    const fieldReadOnly = readOnly || shouldBlockFields;

    // Campos de login e senha só podem ser editados por admins ou pelo próprio usuário
    const canEditLoginPassword = isAdmin || isEditingSelf;

    // Verificar se o formulário tem dados carregados
    const hasFormData = formValues && formValues.id;

    return (
      <form onSubmit={this.submitForm}>
        <div className="box-body">
          {shouldBlockFields && hasFormData && (
            <div className="alert alert-info" style={{ marginBottom: '15px' }}>
              <i className="fa fa-info-circle" />
              <strong> Atenção:</strong> Você só pode editar seus próprios dados. Para alterar outros usuários, entre em
              contato com um administrador.
            </div>
          )}

          <Field
            name="id"
            component={LabelAndInput}
            readOnly={true}
            label="Código"
            cols="12"
            placeholder="Automático"
          />
          <Field
            name="nome"
            component={LabelAndInput}
            label="Nome"
            cols="12"
            placeholder="Informe o nome"
            readOnly={fieldReadOnly}
          />
          <Field
            name="usuario"
            component={LabelAndInput}
            readOnly={!canEditLoginPassword || readOnly}
            label="Email"
            cols="12"
            placeholder="Informe o email para login"
          />
          <Field
            name="senha"
            component={LabelAndInput}
            type="password"
            label="Senha"
            cols="12"
            placeholder="Informe a senha"
            readOnly={!canEditLoginPassword}
          />
          <Field
            name="confirmarSenha"
            component={LabelAndInput}
            type="password"
            label="Confirmar Senha"
            cols="12"
            placeholder="Confirme a senha"
            readOnly={!canEditLoginPassword}
          />

          <SelectGrupoUsuario name="grupo_idgrupo" label="Grupo Usuário" cols="12" disabled={!isAdmin} />

          <Field
            name="gruposFisicos"
            component={renderSelectGrupoFisico}
            label="Permissão Grupo Físico"
            cols="12"
            props={{ readOnly: !isAdmin }}
          />

          <Field name="ativo" component={LabelAndSelectForm} label="Ativo" readOnly={!isAdmin}>
            <option value="1">Sim</option>
            <option value="0">Não</option>
          </Field>
        </div>
        <div className="box-footer ">
          {(isAdmin || isEditingSelf) && (
            <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          )}
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

UsuarioForm = reduxForm({ form: 'usuarioForm', destroyOnUnmount: false })(UsuarioForm);

const mapStateToProps = state => ({
  formValues: getFormValues('usuarioForm')(state),
  user: state.auth.user,
  initialValues: state.form && state.form.usuarioForm && state.form.usuarioForm.initial,
  selectedTab: state.tab.selected,
});
const mapDispatchToProps = dispatch => bindActionCreators({ init, initializeForm: initialize }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsuarioForm);
